import DialogueManageIndexComponent from './component';

class DialogueManageIndexRoute extends DialogueManageIndexComponent {

}

export default DialogueManageIndexRoute;
